import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-channel_2",
  "use": "icon-channel_2-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-channel_2\"><path d=\"M3.58335 13.3333H16.9167V4.16667H3.58335V13.3333ZM11.0834 15V16.6667H14.4167V18.3333H6.08335V16.6667H9.41669V15H2.74319C2.28673 15 1.91669 14.6259 1.91669 14.1604V3.33957C1.91669 2.87589 2.29611 2.5 2.74319 2.5H17.7569C18.2134 2.5 18.5834 2.8741 18.5834 3.33957V14.1604C18.5834 14.6241 18.2039 15 17.7569 15H11.0834Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol